import { useState } from 'react';
import { Input } from '@paulownia/shared/components/ui/input';
import { Label } from '@paulownia/shared/components/ui/label';

interface WeightFieldsProps {
  price?: number;
  onPriceChange: (price: number | undefined) => void;
}

export function WeightFields({ price, onPriceChange }: WeightFieldsProps) {
  const [priceInput, setPriceInput] = useState(price ? String(price) : '');

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="price-kg">Prix au kilo (€/kg) *</Label>
        <Input
          id="price-kg"
          type="text"
          inputMode="decimal"
          value={priceInput}
          onChange={(e) => {
            const val = e.target.value;
            if (val === '' || /^\d*[.,]?\d{0,2}$/.test(val)) {
              setPriceInput(val);
              const normalized = val.replace(',', '.');
              const parsed = parseFloat(normalized);
              onPriceChange(val === '' ? undefined : (isNaN(parsed) ? undefined : parsed));
            }
          }}
          placeholder="ex: 18.00"
        />
        <p className="text-xs text-gray-500">
          Le client pourra saisir le poids souhaité en kg.
        </p>
      </div>
    </div>
  );
}
